import React, { Fragment } from "react";
import { ListBuilder, TileGrid, Form } from "@redriver/cinnamon";
import { PermissionCheck } from "components/auth";
import { HeaderBar, GroupSection } from "components/containers";
import { DocumentTypesDropdown } from "components/forms";
import { Actions, Targets } from "constants/Permissions";
import { addEnquiryDocument, getEnquiryDocuments } from "./actions";
import { AddDocumentsModal } from "components/modals";
import TablePagination from "components/pagination/TablePagination";
import { Container } from "semantic-ui-react";
import EnquiryDocumentTableActions from "./EnquiryDocumentTableActions";

const EnquiryDocumentsPanel = ({ enquiryId, departmentId }) => {
  return (
    <ListBuilder
      withTiles
      loadAction={getEnquiryDocuments}
      loadParams={{ enquiryId }}
      dataTransform={(data) => {
        const items = data.results || [];
        const byType = items.reduce((acc, x) => {
          const key = x.documentTypeName || "unknown";
          acc[key] = acc[key] || [];
          acc[key].push(x);
          return acc;
        }, {});
        const groups = Object.entries(byType).map(([documentType, items]) => ({
          documentType,
          items,
        }));
        return groups;
      }}
      initialPagination={{ pageSize: 25 }}
      totalTransform={(data) => data.totalResults}
      renderList={(tileProps, state, events) => {
        const { pageNumber, pageSize } = state.pagination;
        return (
          <Fragment>
            <Container className="documents-panel" fluid>
              <HeaderBar
                name="Documents"
                rightContent={
                  <PermissionCheck
                    target={Targets.EnquiryDocument}
                    action={Actions.Create}
                  >
                    <AddDocumentsModal
                      submitAction={addEnquiryDocument}
                      submitParams={{ enquiryId }}
                      onAdded={events.onRefresh}
                      documentTypeDropdown={
                        <DocumentTypesDropdown
                          field="documentTypeId"
                          label="Type"
                          placeholder="Select document type"
                          departmentId={departmentId}
                          required
                          fluid
                        />
                      }
                    >
                      <Form.Checkbox field="sendToApp" label="Send to app" />
                    </AddDocumentsModal>
                  </PermissionCheck>
                }
              ></HeaderBar>
              <TileGrid
                {...tileProps}
                dataKey="id"
                render={(item) => {
                  return (
                    <GroupSection
                      group={item}
                      typeActions={(document) => (
                        <EnquiryDocumentTableActions
                          document={document}
                          enquiryId={enquiryId}
                          departmentId={departmentId}
                          onRefresh={events.onRefresh}
                        />
                      )}
                      Id={enquiryId}
                      onRefresh={events.onRefresh}
                      sendToAppTitle="Sent to the app when converted to a job"
                    />
                  );
                }}
              />
            </Container>

            <TablePagination
              pageNumber={pageNumber}
              pageSize={pageSize}
              withPageSize
              pageSizeOptions={[25, 50, 100]}
              onChange={(changes) =>
                events.onChangePagination({
                  ...state.pagination,
                  ...changes,
                })
              }
              totalItems={state.total}
            />
          </Fragment>
        );
      }}
    />
  );
};

export default EnquiryDocumentsPanel;
